<template>
    <div class="essay" :style="{height:pageheight}">
        <div class="top-banner no-select">
            <div class="life-dancing-wrap">
                <svg class="svg" viewBox="0 0 1000 300">
                    <symbol id="line-text">
                        <text text-anchor="middle" x="50%" y="50%" dy=".4em">
                            随手开启笔下生活
                        </text>
                    </symbol>
                    <use xlink:href="#line-text" class="text"></use>
                    <use xlink:href="#line-text" class="text"></use>
                    <use xlink:href="#line-text" class="text"></use>
                    <use xlink:href="#line-text" class="text"></use>
                </svg>
            </div>
        </div>

        <div class="fall-container">
            <ul class="clearfix picture">
                <li class="item" v-for="(items , index) of list" :key="index">
                    <div class="user-header">
                        <div class="user-icon"><img :src="items.adminID?items.adminID.icon:require('../assets/11.jpg')" alt=""></div>
                        <div class="user-name">
                            {{ items.adminID? items.adminID.user_name:'steffen-xuan'}}
                            <p class="clear" style="font-size:11px;color:#aaa">{{ items.created? handle(items.created):'时间都去哪了'}}</p>
                        </div>
                        <div class="user-admire no-select" @click="click(items)">
                            <svg t="1587700917879" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1684" width="30" height="30"><path :fill="items.color?items.color:'#555'" d="M569.6 121.6a19.2 19.2 0 0 1 22.08-18.9824c16.384 2.048 51.5584 25.3056 68.8832 43.392 21.376 19.776 27.0464 52.3712 11.872 78.656l-35.1808 60.9408 0.192-0.0064C614.2784 334.1312 625.7984 358.4 672 358.4h150.0672c42.4128 0 76.8 34.3872 76.8 76.8a76.8 76.8 0 0 1-0.5696 9.2992l-45.2672 371.2A76.8 76.8 0 0 1 776.8 883.2H422.4c-42.4128 0-76.8-34.3872-76.8-76.8V435.2c0-40.2944 31.0336-73.344 70.5024-76.544L416 358.4c21.3632-4.9408 41.1072-20.6912 59.2384-47.2384l86.752-150.2528c0.352-0.608 0.704-1.2096 1.0752-1.792C569.6 144.8512 569.6 139.9488 569.6 121.6zM192 358.4h38.4c35.3472 0 64 28.6528 64 64v396.8c0 35.3472-28.6528 64-64 64h-38.4c-35.3472 0-64-28.6528-64-64V422.4c0-35.3472 28.6528-64 64-64z"  p-id="1685"></path></svg>
                            <span>x{{items.admire}}</span>
                        </div>
                    </div>
                    <h3 class="title no-select" v-if="items.title">{{items.title}}</h3>
                    <a href="#">
                        <img :src="items.images[0]" @load="endLoad" alt="">
                    </a>
                    <p class="info">{{items.textarea}}</p>
                    <div class="tags-wrap">
                        <div class="tag" v-for="(items,index) of items.tags" :key="index">
                            <span>{{items.tag_name}}</span>
                        </div>
                    </div>
                    <div class="hot-comment">感知不强感知不强感知不强感知不强感知不强感知不强</div>
                </li>
                <!-- <li class="item">
                    <div class="user-header">
                        <div class="user-icon"><img src="https://img.xiaohongshu.com/avatar/5b7d198a7e6e15000155f7c9.jpg@80w_80h_90q_1e_1c_1x.jpg" alt=""></div>
                        <div class="user-name">哈哈啊哈肤喝饱水</div>
                        <div class="user-admire" @click="click()">
                            <svg t="1587700917879" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1684" width="30" height="30"><path d="M569.6 121.6a19.2 19.2 0 0 1 22.08-18.9824c16.384 2.048 51.5584 25.3056 68.8832 43.392 21.376 19.776 27.0464 52.3712 11.872 78.656l-35.1808 60.9408 0.192-0.0064C614.2784 334.1312 625.7984 358.4 672 358.4h150.0672c42.4128 0 76.8 34.3872 76.8 76.8a76.8 76.8 0 0 1-0.5696 9.2992l-45.2672 371.2A76.8 76.8 0 0 1 776.8 883.2H422.4c-42.4128 0-76.8-34.3872-76.8-76.8V435.2c0-40.2944 31.0336-73.344 70.5024-76.544L416 358.4c21.3632-4.9408 41.1072-20.6912 59.2384-47.2384l86.752-150.2528c0.352-0.608 0.704-1.2096 1.0752-1.792C569.6 144.8512 569.6 139.9488 569.6 121.6zM192 358.4h38.4c35.3472 0 64 28.6528 64 64v396.8c0 35.3472-28.6528 64-64 64h-38.4c-35.3472 0-64-28.6528-64-64V422.4c0-35.3472 28.6528-64 64-64z" :fill="a_color" p-id="1685"></path></svg>
                            <span>x100</span>
                        </div>
                    </div>
                    <h3 class="title">肌龄重返18岁！一起来沐浴吧！！</h3>
                    <a href="#">
                        <img src="https://image.watsons.com.cn//upload/8a316140.png?w=377&h=451&x-oss-process=image/resize,w_1080" alt="">
                    </a>
                    <p class="info">Lorem ipsum dolor sit amet,  consectetur adipisicing elit consectetur adipisicing elit consectetur adipisicing elit consectetur adipisicing elit consectetur adipisicing elitconsectetur adipisicing elit</p>
                    <div class="tags-wrap">
                        <div class="tag">
                            <span>vue.js</span>
                        </div>
                    </div>
                    <div class="hot-comment">感知不强感知不强感知不强感知不强感知不强感知不强</div>
                </li>
                <li class="item">
                    <div class="user-header">
                        <div class="user-icon"><img src="https://img.xiaohongshu.com/avatar/5b7d198a7e6e15000155f7c9.jpg@80w_80h_90q_1e_1c_1x.jpg" alt=""></div>
                        <div class="user-name">哈哈啊哈肤喝饱水</div>
                    </div>
                    <h4 class="title">哈哈啊哈肤喝饱水</h4>
                    <a href="#">
                        <img src="https://statics.oneplus.cn/ov/assets/images/events/instant-noodle/19811/pics/full/3.webp" alt="">
                    </a>
                    
                    <p class="info">Lorem ipsum dolor sit amet,  consectetur adipisicing elit consectetur adipisicing elit consectetur adipisicing elit consectetur adipisicing elit consectetur adipisicing elitconsectetur adipisicing elit</p>
                </li>
                <li class="item">
                    <div class="user-header">
                        <div class="user-icon"><img src="https://img.xiaohongshu.com/avatar/5b7d198a7e6e15000155f7c9.jpg@80w_80h_90q_1e_1c_1x.jpg" alt=""></div>
                        <div class="user-name">哈哈啊哈肤喝饱水</div>
                    </div>
                    <h4 class="title">哈哈啊哈肤喝饱水</h4>
                    <a href="#">
                        <img src="https://statics.oneplus.cn/ov/assets/images/events/instant-noodle/19811/pics/full/3.webp" alt="">
                    </a>
                    
                    <p class="info">Lorem ipsum dolor sit amet,  consectetur adipisicing elit consectetur adipisicing elit consectetur adipisicing elit consectetur adipisicing elit consectetur adipisicing elitconsectetur adipisicing elit</p>
                </li>
                <li class="item">
                    <div class="user-header">
                        <div class="user-icon"><img src="https://img.xiaohongshu.com/avatar/5b7d198a7e6e15000155f7c9.jpg@80w_80h_90q_1e_1c_1x.jpg" alt=""></div>
                        <div class="user-name">哈哈啊哈肤喝饱水</div>
                    </div>
                    <h4 class="title">哈哈啊哈肤喝饱水</h4>
                    <a href="#">
                        <img src="https://statics.oneplus.cn/ov/assets/images/events/instant-noodle/19811/pics/full/3.webp" alt="">
                    </a>
                    
                    <p class="info">Lorem ipsum dolor sit amet,  consectetur adipisicing elit consectetur adipisicing elit consectetur adipisicing elit consectetur adipisicing elit consectetur adipisicing elitconsectetur adipisicing elit</p>
                </li> -->
            </ul>
            <!-- <div id="load">can you see me?</div> -->
        </div>

    </div>
</template>

<script>
export default {
    data(){
        return{
            a_color:'#2c2c2c',
            screenWidth: document.documentElement.clientWidth || window.innerWidth,
            list:[],
            pageheight:'200vh',
        }
    },
    created(){
        this.fetch();
    },
    mounted(){
        // this.$nextTick(()=>{    
        //     this.fall();                 
        // });
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.documentElement.clientWidth || window.innerWidth;
            })()
        }
        
    },
    watch:{
        screenWidth(){
            this.fall();
        },
        list(){
            this.$nextTick(()=>{    
                clearInterval(this.imgSetInterval);
                this.imgSetInterval=setInterval(()=> {
                    this.fall(); 
                    clearInterval(this.imgSetInterval)
                },20)                   
            });
        }
    },
    methods:{
        fall(){
            const minGap = 10; // 最小间距，让每一列的最小空隙可以自定义，避免太过拥挤的情况发生。但是，会通过计算得到真实的间距。
            const items = document.querySelectorAll('.fall-container .clearfix li'); // 获取所有的外层元素
            const itemWidth = items[0].offsetWidth; // 每一项的宽度，即当前每一个图片容器的宽度。保证每一列都是等宽不等高的。
            const pageWidth = this.screenWidth; // 获取当前页面的宽度 = window.innerWidth - 滚动条的宽度
            const column = Math.floor(pageWidth / (itemWidth + minGap)); // 实际列数
            const gap = (pageWidth - itemWidth * column) / column / ((column + 1) / column); // 计算真实间距
            
            const heightArr = []; // 定义一个空数组，保存最低高度。
            for (let i = 0; i < items.length; i++) {
                // 遍历所有的外层容器
                const height = items[i].offsetHeight;
                // 如果当前处在第一列
                if (i < column) {
                    // 直接设置元素距离上部的位置和距离左边的距离。
                    items[i].style.cssText = `top: ${gap * 0.8}px;left: ${(itemWidth + gap) * i + gap}px`;
                    // 保存当前元素的高度。
                    heightArr.push(height);
                } else {
                    // 不是第一列的话，就进行比对。
                    let minHeight = heightArr[0]; // 先保存第一项的高度
                    let minIndex = 0; // 保存第一项的索引值
                    for (let j = 0; j < heightArr.length; j++) {
                        // 通过循环遍历比对，拿到最小值和最小值的索引。
                        if (minHeight > heightArr[j]) {
                            minHeight = heightArr[j];
                            minIndex = j;
                        }
                    }
                    // 通过最小值为当前元素设置top值，通过索引为当前元素设置left值。
                    items[i].style.cssText = `top: ${minHeight + gap *1.5}px; left: ${(itemWidth + gap) * minIndex + gap}px`;
                    // 并修改当前索引的高度为当前元素的高度
                    heightArr[minIndex] = minHeight + gap + height;
                }
            }
            
            this.pageheight = heightArr[0]+(minGap*2*(items.length/column)+100)+(document.documentElement.clientHeight || window.innerHeight)+'px';
        },
        click(i){
            if(i.isAdmire === undefined){i.isAdmire = true}
            if(i.isAdmire){
                i.color = '#59AAFF'
                i.admire++;
                i.isAdmire = false;
                this.$http.put(`rest/essay/${i._id}`,{admire:i.admire});
            }
            
        },
        async fetch(){
            const res = await this.$http.get('rest/essay');
            this.list = res.data;
            if(!res.status==200){
                this.$message({
                type:'error',
                message:'请检查网络连接'
                })
                return;
            }
        },
        endLoad(){
            this.fall(); 
        },
        handle(createTime){
            return this.timestampToTime(this.getTimestamp(createTime)) 
        },
        getTimestamp(time) { //把时间日期转成时间戳
            return (new Date(time)).getTime()
        },
        timestampToTime (value) {
            let date = new Date(value);
            let y = date.getFullYear();// 年
            let MM = date.getMonth() + 1;// 月
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();// 日
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();// 时
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();// 分
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();// 秒
            s = s < 10 ? ('0' + s) : s;
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
        },
    }
}
</script>

<style lang="scss">
.essay{
    height: 100vh;
    .top-banner{
        height: 60vh;
        background: #222;
        .life-dancing-wrap{
            font-size: 85px;
            font-weight: bold;
            .svg{
                width: 100%;
                height: 60vh;
                .text{
                    fill: none;
                    stroke-width: 5;
                    stroke-dasharray: 0 240;
                    stroke-dashoffset: 0;
                    letter-spacing: 1rem;
                    &:nth-child(4n+1){
                        stroke: rgb(23, 120, 223);
                        animation: dancetext1 4s ease-in-out forwards;
                        
                    }
                    &:nth-child(4n+2){
                        stroke: rgb(57, 175, 100);
                        animation: dancetext2 4s ease-in-out forwards;
                        // stroke-dashoffset: 1060;
                        // stroke-dasharray: 60 180;
                    }
                    &:nth-child(4n+3){
                        stroke: rgb(243, 188, 69);
                        animation: dancetext3 4s ease-in-out forwards;
                        // stroke-dashoffset: 1120;
                        // stroke-dasharray: 60 180;
                    }
                    &:nth-child(4n+4){
                        stroke: rgb(221, 72, 61);
                        animation: dancetext4 4s ease-in-out forwards;
                        // stroke-dashoffset: 1180;
                        // stroke-dasharray: 60 180;
                    }
                }

            }
        }
    }
    .fall-container{
        width: 100%;
        height: auto;
        margin: 0 auto;
        .clearfix::after {
            content: "";
            display: block; 
            clear: both;
        }
        .picture {
            position: relative;
            .item {
                position: absolute;
                padding: 0 0 10px 0;
                width: 400px;
                margin: 10px;
                border: 2px solid #f0f0f0;
                border-radius: 12px;
                box-shadow: 1px 1px 10px #dfdfdf;
                background: #fff;
                opacity: 1;
                transition: all .7s ease-out;
                &:hover{
                    box-shadow:0 22px 43px rgba(0,0,0,.13);
                    transform:translateY(-3px) scale(1.01);
                    -moz-transform:translateY(-3px) scale(1.01);
                    -o-transform:translateY(-3px) scale(1.01);
                }
                .user-header{
                    display: flex;
                    flex-direction: row;
                    .user-icon{
                        padding: 8px;
                        width: 50px;
                        height: 50px;
                        img{border-radius: 50%;width: 100%;height: auto;}
                    } 
                    .user-name{
                        margin: auto 10px; 
                        color: #888;
                        font-weight: 700;
                        
                    }
                }
                a{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 10px;        
                    img {
                        max-width: 100%;
                        width: 100%;
                        height: auto;
                        border-radius: 10px;
                    }
                }  
                .title {
                    height: auto;
                    color: #333;
                    margin: 0 15px;
                    padding: 10px 0;
                    border-bottom: 1px solid #ddd;
                }
                .info {
                    font-size: 14px;
                    line-height: 1.8;
                    margin: 5px 16px 0;
                    color: #888;
                }
                .tags-wrap{
                    max-width: 100%;
                    display: flex;
                    flex-direction: row;
                    margin: 12px;
                    flex-wrap: wrap;
                    .tag{
                        background: #efefef;
                        padding: 4px 8px;
                        border-radius: 3px;
                        margin: 5px;
                        span{
                            font-size: 12px;
                            padding: 3px;
                            color: #898;
                        }
                    }
                }
                .hot-comment{
                    padding: 12px;
                    margin: 10px 15px 0;
                    background: #ebebeb;
                    border-radius: 10px;
                    color: #555;
                }
                .user-admire{
                    margin: auto;
                    display: flex;
                    margin-right: 10px;
                    cursor: pointer;
                    span{
                        color: #555;
                        font-size: 12px;
                    }
                }
            }
        }
    }
}

#load {
 
}
@keyframes dancetext1 {
    100%{
        stroke-dashoffset: 1000;
        stroke-dasharray: 60 180;
    }
}
@keyframes dancetext2 {
    100%{
        stroke-dashoffset: 1060;
        stroke-dasharray: 60 180;
    }
}
@keyframes dancetext3 {
    100%{
        stroke-dashoffset: 1120;
        stroke-dasharray: 60 180;
    }
}
@keyframes dancetext4 {
    100%{
        stroke-dashoffset: 1180;
        stroke-dasharray: 60 180;
    }
}
</style>